import type { Database } from "@/integrations/supabase/types";

export type LegalReviewStatus = Database["public"]["Enums"]["kb_legal_review_status"];
export type VerificationStatus = Database["public"]["Enums"]["agora_verification_status"];
export type TrustLevel = Database["public"]["Enums"]["agora_trust_level"];
export type LegalSourceType = Database["public"]["Enums"]["agora_legal_source_type"];

export type AgoraAuthorSummary = {
  id: string;
  slug: string;
  display_name: string;
  profession: string | null;
  organization_name: string | null;
  avatar_url: string | null;
  verification_status: VerificationStatus;
  trust_level: TrustLevel;
};

export type AgoraAuthorCard = AgoraAuthorSummary & {
  bio: string | null;
  domains: string[];
  articles_count: number;
  total_views: number;
  is_demo: boolean;
};

/** Données de prestige de l'auteur, jointes uniquement sur la page d'analyse. */
export type AgoraAuthorProfileExtras = {
  bio: string | null;
  domains: string[];
  articles_count: number;
  total_views: number;
};

export type AgoraCategory = {
  id: string;
  name: string;
  slug: string;
  description?: string | null;
};

export type AgoraArticleCard = {
  id: string;
  slug: string;
  title: string;
  primary_question: string | null;
  short_answer: string | null;
  key_points: string[];
  cover_image_url: string | null;
  reading_minutes: number | null;
  published_at: string | null;
  last_reviewed_at: string | null;
  legal_review_status: LegalReviewStatus;
  is_featured: boolean;
  is_demo: boolean;
  views_count: number;
  category: AgoraCategory | null;
  author: AgoraAuthorSummary | null;
};

export type AgoraArticleSource = {
  id: string;
  source_type: LegalSourceType;
  title: string;
  reference: string | null;
  jurisdiction: string | null;
  number: string | null;
  source_date: string | null;
  url: string | null;
  comment: string | null;
  order_index: number;
};

export type AgoraArticleFaq = {
  id: string;
  question: string;
  answer: string;
  order_index: number;
};

export type AgoraArticleFull = AgoraArticleCard & {
  content: string;
  subtopics: string[];
  keywords: string[];
  valid_until: string | null;
  updated_at: string;
  author_profile: AgoraAuthorProfileExtras | null;
  sources: AgoraArticleSource[];
  faqs: AgoraArticleFaq[];
};

export type AgoraArticleResult =
  | { kind: "article"; article: AgoraArticleFull; related: AgoraArticleCard[] }
  | { kind: "redirect"; to: string }
  | { kind: "not_found" };

export const SOURCE_TYPE_LABELS: Record<LegalSourceType, string> = {
  legislation: "Texte législatif",
  case_law: "Jurisprudence",
  administrative_source: "Source administrative",
  regulator: "Autorité de régulation",
  doctrine: "Doctrine",
  other: "Autre source",
};
